/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-09-27 16:02:16
 * @LastEditors: K
 * @LastEditTime: 2022-10-09 09:27:30
 */
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Dropdown,
  Form,
  Input,
  Menu,
  Modal,
  notification,
  Radio,
  Row,
  Select,
  Space,
  Tag,
} from 'antd'
import moment from 'moment'
import React, { ReactElement, useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../app/store'
import { ThemeContext } from '../../theme/ThemeContext'
import { PlusOutlined, SearchOutlined } from '@ant-design/icons'
import { getGenderName } from '../../models/user'
import { getAge } from '../../utils/StringUtils'
import { bindMember, getMemberCardSearchList, getMembersPage } from './MembersManagementPageSlice'
import { decrypt } from '../../models/m'
import { getMaskPhone } from '../../models/phone'
import { AddOrEditMemberCardModal } from './detail/addOrEditMemberCardModal'
import styles from  './MembersManagementPage.module.css'

interface AddMembersModalProps {
  QXData?: any
  cardData?: any
  visible: boolean
  onCancel: () => void
  onOk: () => void
  editId?: any
}

export const BindMembersModal = ({
  QXData,
  cardData,
  visible,
  onCancel,
  onOk,
  editId,
}: AddMembersModalProps): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const theme = useContext(ThemeContext)

  const [btnLoading, setBtnLoading] = useState(false)

  const [
    isPatientNameOverlayVisible,
    setIsPatientNameOverlayVisible,
  ] = useState(false)

  const [keyword, setKeyword] = useState('')

  const [keywords, setKeywords] = useState('')

  const [patients, setPatients] = useState<any>([])

  const [memberId, setMemberId] = useState('')

  const [memberCardData, setMemberCardData] = useState<any>([])

  const [cardModalVisible, setCardModalVisible] = useState(false)

  const [phoneInfo, setPhoneInfo] = useState<any>({})

  const patientOverlay = (
    <Menu style={{ maxHeight: 360, overflow: 'auto' }}>
      {patients.map((p: any) => (
        <Menu.Item
          key={p.id}
          onClick={() => {
            form.setFieldsValue({
              patientId: p.id,
              memberName: p.memberName,
              memberPhone: p.memberPhone ? (!QXData ? getMaskPhone(decrypt(p.memberPhone)) : decrypt(p.memberPhone) ) : '',
              sexType: String(p.sexType),
              birthday: p.birthday,
            })
            updateYearsAndMonths(p.birthday)
            setKeywords(p.memberName)
            setIsPatientNameOverlayVisible(false)
            setMemberId(p.id)
            setPhoneInfo({
              phone: p.memberPhone,
              phoneDisabled: p.memberPhone && !QXData,
            })
          }}
        >
          <Space>
            <span>{p.memberName}</span>
            <span>{getGenderName(p.sexType)}</span>
            <span>{getAge(p?.ageYear, p?.ageMonth, '岁')}</span>
            <span>{p.memberPhone ? (!QXData ? getMaskPhone(decrypt(p.memberPhone)) : decrypt(p.memberPhone) ) : ''}</span>
            <span>{p.id}</span>
          </Space>
        </Menu.Item>
      ))}
    </Menu>
  )

  const updateBirthday = () => {
    if (form) {
      const year = parseInt(form.getFieldValue('age')) || 0
      const month = parseInt(form.getFieldValue('ageMonth')) || 0
      if (year !== 0 || month !== 0) {
        const months = year * 12 + month
        const birthday = moment()
          .subtract(months, 'months')
          .format('YYYY/MM/DD')
        form.setFieldsValue({ birthday })
      }
    }
  }

  const updateYearsAndMonths = (birthday?: any) => {
    if (form) {
      const date = moment(birthday) || moment(form.getFieldValue('birthday'))
      if (!date.isValid()) {
        return
      }
      const duration = moment.duration(moment().diff(date))
      if (duration.years() < 0 || duration.months() < 0) {
        return
      }

      form.setFieldsValue({
        ageYear: duration.years(),
        age: duration.years(),
        ageMonth: duration.months() == 0 ? 1 : duration.months(),
      })
    }
  }

  useEffect(() => {
    if (!visible) {
      form.resetFields()
      setKeywords('')
      setKeyword('')
      setMemberId('')
      setPhoneInfo({})
    }
  }, [visible])

  useEffect(() => {
    if (visible) {
      getPatientListPage(keyword || keywords)
    }
  }, [dispatch, visible, keyword, keywords])

  useEffect(() => {
    if (visible) {
      if (cardData?.cardNo) {
        getDataList(cardData?.cardNo)
      } else {
        getDataList()
      }
    } else {
      setMemberCardData([])
    }
  }, [visible])

  useEffect(() => {
    if (visible) {
      if (cardData?.cardNo)
        form.setFieldsValue({
          memberCardId: cardData?.cardNo,
          balance: cardData?.balance,
        })
    }
  }, [visible])

  const getPatientListPage = (keyword: any) => {
    dispatch(getMembersPage({
      current: 1, size: 30, keyWord: keyword
    }))
      .then(unwrapResult)
      .then((res: any) => {
        setPatients(
          res?.memberPageVO?.records.map((item: any) => {
            const duration = moment.duration(moment().diff(item.birthday))
            return {
              ...item,
              ageYear: duration.years(),
              age: duration.years(),
              ageMonth: duration.months() == 0 ? 1 : duration.months(),
            }
          }),
        )
      })
  }

  const getDataList = (v?: any) => {
    dispatch(
      getMemberCardSearchList({
        param: v,
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        setMemberCardData(res.records)
        if (res?.records?.length) {
          if (res?.records?.length == 1) {
            form.setFieldsValue({
              memberCardId: res.records[0].cardNo,
              balance: res.records[0].balance,
            })
          }
        } else {
          form.setFieldsValue({
            balance: '',
          })
        }
      })
  }

  const checkMemberCard = (v: any, params: any, isCheck?: any) => {
    if (v && v.length > 0) {
      Modal.confirm({
        title: '提示',
        okText: '确认无误，继续',
        content: (
          <p>
            {v}
          </p>
        ),
        onOk: () => {
          save(params, isCheck);
        },
        onCancel: () => {
          setBtnLoading(false)
        }
      })
    } else {
      return
    }
  }

  const save = (params: any, isCheck?: any) => {
    setBtnLoading(true)
    dispatch(bindMember({ ...params, isCheck: isCheck?.toString() || 1 ,pageName : location.pathname}))
      .then(unwrapResult)
      .then((v) => {
        if (v && v.length > 0) {
          checkMemberCard(v, params, '0')
        } else {
          setBtnLoading(false)
          notification.success({
            message: '操作成功',
          })
          onOk()
          setBtnLoading(false)
        }
      })
      .catch(() => {
        setBtnLoading(false)
      })

  }

  return (
    <>
    <Modal
      visible={visible}
      title={'会员卡绑定'}
      width={700}
      cancelText='取消'
      okText='确定'
      confirmLoading={btnLoading}
      maskClosable={false}
      onCancel={onCancel}
      onOk={form.submit}
      className={styles.bindMemberModal}
    >
      <Form
        form={form}
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 19 }}
        autoComplete='off'
        onFinish={(values) => {
          const memberCard = memberCardData.find((item: any) => item.cardNo == values.memberCardId)
          if (values.memberCardId != memberCard?.cardNo) {
            notification.error({
              message: '卡号不正确，请重新输入会员实体卡卡号',
            })
            return
          }
          const params = {
            memberCardId: memberCard.id,
            memberId: memberId,
          }
          save(params, 1)
        }}
      >
        <Form.Item
          label='会员卡号'
          name='memberCardId'
          rules={[
            {
              required: true,
              message: '请输入会员卡号',
            },
          ]}
        >
          <Input
            allowClear
            placeholder='请刷卡/输入会员卡号'
            prefix={<SearchOutlined style={{ color: theme.tc3 }} />}
            addonAfter={
              <Button
                type='link'
                style={{ padding: '0' }}
                onClick={() => setCardModalVisible(true)}
                icon={<PlusOutlined />}
              >
                新增实体卡
              </Button>
            }
            onChange={(e: any) => {
              getDataList(e.target.value)
              if (!e?.target?.value) {
                form.setFieldsValue({
                  balance: '',
                })
              }
            }}
          />
        </Form.Item>
        <Form.Item
          label='会员卡金额'
          name='balance'
        >
          <Input placeholder='请输入会员卡金额' disabled />
        </Form.Item>
        <Form.Item label='关联患者姓名' name='memberName' rules={[{ required: true }]}>
          <Dropdown
            overlay={patientOverlay}
            visible={isPatientNameOverlayVisible}
            onVisibleChange={((v) => {
              setIsPatientNameOverlayVisible(v)
            })}
          >
            <Input
              allowClear
              placeholder='请刷卡/输入姓名'
              prefix={<SearchOutlined style={{ color: theme.tc3 }} />}
              value={keywords}
              onFocus={() => {
                getPatientListPage(keywords)
                setIsPatientNameOverlayVisible(true)
              }}
              onBlur={() => {
                setTimeout(() => {
                  setIsPatientNameOverlayVisible(false)
                }, 300)
              }}
              onClick={() => {
                setIsPatientNameOverlayVisible(true)
              }}
              onChange={(e) => {
                setIsPatientNameOverlayVisible(true)
                setKeywords(e.target.value)
                setKeyword('')
              }}
            />
          </Dropdown>
        </Form.Item>
        <Form.Item
          label='手机号'
          name='memberPhone'
          rules={[
            phoneInfo?.phoneDisabled ? {} : {
              required: true,
              pattern: new RegExp(/^1[3|4|5|6|7|8|9][0-9]\d{8}$/),
              message: '请输入正确的会员手机号码',
            },
          ]}
        >
          <Input disabled placeholder='请输入手机号' />
        </Form.Item>
        <Form.Item label='性别' name='sexType' rules={[{ required: true }]}>
          <Radio.Group disabled>
            <Radio value='1'>男</Radio>
            <Radio value='2'>女</Radio>
            <Radio value='0'>未知</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item label='年龄' required>
          <Row wrap={false} align='middle'>
            <Form.Item
              name='age'
              noStyle
              dependencies={['ageMonth']}
              rules={[
                {
                  pattern: /^\d{0,3}$/,
                  message: '请输入正确的年龄',
                },
                ({ getFieldValue }) => ({
                  validator: (_, value) => {
                    if (!value && !getFieldValue('ageMonth')) {
                      return Promise.reject(new Error('请输入正确的年龄'))
                    }
                    return Promise.resolve()
                  },
                }),
              ]}
            >
              <Input onChange={updateBirthday} style={{ maxWidth: '3rem' }} disabled />
            </Form.Item>
            <div
              style={{
                color: theme.tc2,
                fontSize: '1rem',
                margin: '0 6px',
              }}
            >
              岁
            </div>
            <Form.Item
              name='ageMonth'
              noStyle
              dependencies={['ageYear']}
              rules={[
                {
                  pattern: /^(0?[0-9]|1[0-1])$/,
                  message: '请输入正确的月份',
                },
              ]}
            >
              <Input
                disabled
                onChange={updateBirthday}
                style={{ maxWidth: '3rem' }}
              />
            </Form.Item>
            <div
              style={{
                color: theme.tc2,
                fontSize: '1rem',
                margin: '0 6px',
              }}
            >
              月
            </div>
            <Form.Item
              name='birthday'
              noStyle
              style={{ flex: 1 }}
              rules={[
                { max: 16, message: '最多16个字' },
                {
                  pattern: /^\d{4}\/\d{1,2}\/\d{1,2}$/,
                  message: '年龄格式为YYYY/MM/DD',
                },
              ]}
            >
              <Input
                onChange={(v) => {
                  updateYearsAndMonths(v?.target?.value)
                }}
                disabled
              />
            </Form.Item>
          </Row>
        </Form.Item>
        <Form.Item label='生日' name='birthday'>
          <Input placeholder='请输入生日' disabled />
        </Form.Item>
      </Form>
    </Modal>
    <AddOrEditMemberCardModal
      visible={cardModalVisible}
      onCancel={() => setCardModalVisible(false)}
      onOk={(data: any) => {
        setCardModalVisible(false)
        getDataList(data?.cardNo)
      }}
    />
    </>
  )
}
